import React from "react"
import PropTypes from "prop-types"
import styled, { css } from "styled-components"
import theme from "@styles/theme"
import Flex from "./flex"
import { cssConfig } from "@utils/css-validator"
import media from "../../styles/media"
import { handleMobileSize } from "./helpers"

const StyledList = styled(Flex).withConfig(cssConfig)`
  list-style-type: ${props =>
    props.listStyle ?? (props.as === "ul" ? "disc" : "decimal")};

  margin: ${props => props.inherit && "0 0 0 2rem"};

  font-size: ${({ inherit, fontSize }) => (inherit ? "inherit" : fontSize)};

  ${media.sm`
	  font-size: ${({ inherit, fontSize, mobileScale }) =>
      inherit ? "inherit" : handleMobileSize(fontSize, mobileScale)};
  `}

  ${media.sm_up`
	  font-size: ${({ inherit, fontSize, tabletScale }) =>
      inherit ? "inherit" : handleMobileSize(fontSize, tabletScale)};
	`}

	${media.md_up`
    font-size: ${({ inherit, fontSize }) => (inherit ? "inherit" : fontSize)};
	`}

  li {
    color: ${props => props.color ?? props.theme.color.blue700};
    text-align: ${props => props.center && "center"};
    line-height: ${props => props.lineHeight ?? "1.9"};
    margin: 0 !important;
    font-size: inherit;
    font-weight: inherit;
    padding: ${props => props.itemPadding};
    &:not(:last-child) {
      border-bottom: ${props => props.borderBottom};
    }
  }

  ${props =>
    props.checkmarks &&
    css`
      list-style-type: none;
      position: relative;
      margin-left: 0;
      li {
        padding-left: 2rem;
        &:before {
          position: absolute;
          width: 1rem;
          height: 1rem;
          left: 0;
          content: "✓";
          margin-right: 1rem;
        }
      }
    `}
`

StyledList.defaultProps = {
  fontSize: theme.defaults.fontSize.p,
  as: "ul",
  gap: "1rem",
  tabletScale: 0.9,
  mobileScale: 0.8,
}

StyledList.propTypes = {
  as: PropTypes.oneOf(["ul", "ol"]),
  listStype: PropTypes.string,
  borderBottom: PropTypes.string,
  itemPadding: PropTypes.string,
  color: PropTypes.string,
  center: PropTypes.bool,
  lineHeight: PropTypes.string,
  inherit: PropTypes.bool,
  tabletScale: PropTypes.number,
  mobileScale: PropTypes.number,
}

const List = ({ children, ...rest }) => {
  return <StyledList {...rest}>{children}</StyledList>
}

List.propTypes = {
  inherit: PropTypes.bool,
  children: PropTypes.node,
}

export default List
